<template>
  <div class="contents5">
    <img class="bg" :src="bgImg" />
    <div class="contents">
      <p class="text1">B2B <br v-if="isMobile" />스마트 관제 서비스</p>
      <p class="text2">
        고객사 시스템 연동을 통한 <br v-if="isMobile" />정비 이력 관리 환경 제공<br />
        실시간 모니터링 및 정산 자동화<br />
        서비스 품질 관리<br />
        표준화된 순회 정비 서비스<br />
        전국 순회 정비망 구축
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: 'static/img/main-content/contents5.png',
      isMobile: false,
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.bgImg = 'static/img/main-content/contents5.png'
        this.isMobile = false
      } else {
        this.bgImg = 'static/img/mobile/main-content/contents5.png'
        this.isMobile = true
      }
    },
  },
}
</script>

<style scoped>
.contents5 {
  width: 100%;
  position: relative;
}
.contents5 .bg {
  width: 100%;
  height: auto;
  display: block;
}

/* pc */
@media (max-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 37px;
    line-height: 40px;
    color: #000000;
    margin-bottom: 2%;
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 13px;
    line-height: 23px;
    color: #444444;
  }
}
@media (min-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 2.9vw;
    line-height: 3.6vw;
    color: #000000;
    margin-bottom: 2%;
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 1vw;
    line-height: 1.8vw;
    color: #444444;
  }
}
@media (min-width: 641px) {
  .contents5 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 5% 0 0 0;
    text-align: center;
  }
}
/* mobile */
@media (max-width: 640px) {
  .contents5 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    text-align: center;
  }
  .text1 {
    margin-top: 20%;

    font-style: normal;
    font-weight: 300;
    font-size: 6.4vw;
    line-height: 10vw;
    color: #000000;
    margin-bottom: 5%;
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 4vw;
    line-height: 6vw;
    color: #444444;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/Contents5.vue